export default __webpack_public_path__ + "static/media/perpertualsuccour.4fbc68b1.jpg";